export const REGISTRATION_NUMBER_CHARACTER_LIMIT = 10;
